import { ExtendableError } from 'ts-error';

export class HttpException extends ExtendableError {

  private readonly _status: number;

  constructor(status?: number, ...params) {
    super(...params);

    this._status = status;
  }

  get status(): number {
    return this._status;
  }

}
